(function(){
  const popup = document.getElementById('notice-popup');
  const closeBtn = document.getElementById('popup-close');
  const hideTodayCheckbox = document.getElementById('hide-today');

  // ====== 설정 ======
  const startDate = new Date('2026-10-08T00:00:00'); // 노출 시작일
  const endDate   = new Date('2026-10-31T23:59:59'); // 노출 종료일 (확인 필요)
  // =================

  function isWithinSchedule(){
    const now = new Date();
    return now >= startDate && now <= endDate;
  }

  // 언어별 주소(/ja, /es, /zh …)의 접두어를 떼고 경로를 돌려준다 — /ja 홈도 홈으로 인정
  function getPath(){
    var path = window.location.pathname;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root !== '/') {
      var prefix = root.replace(/\/$/, '');
      if (path === prefix) return '/';
      if (path.indexOf(prefix + '/') === 0) return path.slice(prefix.length) || '/';
    }
    return path;
  }

  function getStorageKey(){
    const path = getPath();
    if (path === "/") {
      return 'popup-hide-today-home'; // 메인 페이지 전용
    } else if (path.includes("/products/")) {
      return 'popup-hide-today-product'; // 상품 상세 전용
    }
    return 'popup-hide-today-other'; // 혹시 다른 경우
  }

  function isHiddenToday(){
    const STORAGE_KEY = getStorageKey();
    const savedDate = localStorage.getItem(STORAGE_KEY);
    const today = new Date().toDateString();
    return savedDate === today;
  }

  function isAllowedPage(){
    // 홈에서만 노출 (2026-10-08 MU:DS부터. 상품 상세에도 띄우려면 path.includes("/products/") 조건을 추가)
    const path = getPath();
    return path === "/";
  }

  function showPopup(){
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function hidePopup(){
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function saveHideToday(){
    if(hideTodayCheckbox.checked){
      const STORAGE_KEY = getStorageKey();
      localStorage.setItem(STORAGE_KEY, new Date().toDateString());
    }
  }

  // 초기 실행
  if(isAllowedPage() && isWithinSchedule() && !isHiddenToday()){
    showPopup();
  }

  closeBtn.addEventListener('click', () => {
    saveHideToday();
    hidePopup();
  });

  popup.addEventListener('click', (e) => {
    if(e.target === popup){
      saveHideToday();
      hidePopup();
    }
  });
})();